import React, { Component } from 'react'
import {Link, navigate} from 'gatsby'
import {
	Button,
	Header,
	Icon,
	Portal,
	Search,
	Segment
} from 'semantic-ui-react'
import * as styles from './styles/searchBar.module.css'
import {
	mobileMaxWidth,
	resizeTimer,
	searchBarColor,
} from '../../globalVar'
import { SearchContext } from '../Context/SearchContext'

//const Negosyo = require('../../../lib/negosyo')
// const Logger = require('../../../lib/logger')

const initialState = { isLoading: false, results: [], value: '' }

export default class SearchBarMobile extends Component {
	static contextType = SearchContext;
	state = {
		...initialState,
		open:false,
		tablet:undefined,
		timeOut:undefined
	}

	componentDidMount() {
		this.resizeHandler();
		window.addEventListener('resize', this.resizeConsolidator);
	}

	resizeConsolidator = () => {
		clearTimeout(this.state.timeOut);
		const temp = setTimeout(this.resizeHandler, resizeTimer)
		this.setState({
			timeOut:temp
		})
	}

	resizeHandler = () => {
		if(window.innerWidth > mobileMaxWidth ) {
			this.setState({tablet:true});
		}else {
			if(this.state.tablet===true) {
				this.setState({open:false})
			}
			this.setState({tablet:false});
		}
	}

	componentWillUnmount() {
		clearTimeout(this.state.timeOut);
		window.removeEventListener('resize', this.resizeConsolidator);
	}

	handleKeyPress = (event) => {
		if(event.key==="Enter") {
			this.handleButtonClick();
		}
	}

	handleButtonClick = (event) => {
		const searchValue = this.context.data;
		if(searchValue.length > 0 ) {
			this.setState({open:false, value: searchValue});
			this.props.closeModal()
			const searchQuery = encodeURIComponent(searchValue);
			navigate(`/search/?search_query=${searchQuery}`)
		}
	}

	handleSearchChange = (e, { value }) => {
		//isLoading: true,previously in setState but took it out since there's no api being called
		this.setState({ value}, ()=>{

			if (this.state.value.length < 1) {
				this.setState(initialState)
			}else {
				/*
				Negosyo.getProductSearchText(this.state.value).then((response)=> {
					const temp = response.map(this.mapNegosyoResults)

					this.setState({
						isLoading: false,
						results:temp
					})
				}).catch((err)=> {
					//Logger.log(err);
				})
				*/
			}
		})
		this.context.updateData(value)
	}

	mapNegosyoResults = ({name, mainImageHref, description, meta, id}) => {
		return (
			{
				as:Link,
				to:`/product/${id}/`,
				title:name,
				image:mainImageHref,
				description:description.length > 50 ? `${description.substring(0,50)}...`:description,
				price:`${meta.display_price.with_tax.currency}${meta.display_price.with_tax.amount}`,
			}

		)
	}

	render() {
		const { isLoading, value, results, open, tablet } = this.state
		const searchValue = this.context.data;
		return (
			<React.Fragment>
				{ tablet ? (
					<Search
						input={{
							className:styles.inputTablet,
							input:<input type="text" ></input>,
							action:{
								color:searchBarColor,
								icon:'search',
								loading:isLoading,
								onClick:this.handleButtonClick
							},
							placeholder:"Search NegosyoNow"
						}}
						icon={{
							name:''
						}}
						onSearchChange={this.handleSearchChange}
						results={results}
						value={searchValue}
						className={styles.input}
						onKeyPress={this.handleKeyPress}
						showNoResults={false}
					/>
				):(
					<React.Fragment>
						<Icon
							name="search"
							onClick={()=>{
								this.props.closeModal()
								this.setState({
									open:true
								})
							}}
						/>
						<Portal open={open}>
							<Segment className={styles.segment}>
								<div className={styles.div}>
									<Button
										aria-label="Close Navigation"
										onClick={()=>{
											this.setState({open:false})
										}}
										className={styles.closeButton}
									>
										<Icon fitted name={"cancel"} className={styles.icon}/>
									</Button>
									<Header className={styles.superHeader}>
										Search
									</Header>
									<Search
										input={{
											className:styles.inputMobile,
											input:<input type="text" ></input>,
											action:{
												color:searchBarColor,
												icon:'search',
												loading:isLoading,
												onClick:this.handleButtonClick
											},
											placeholder:"Search NegosyoNow"
										}}
										icon={{
											name:''
										}}
										onSearchChange={this.handleSearchChange}
										results={results}
										value={searchValue}
										className={styles.input}
										onKeyPress={this.handleKeyPress}
										showNoResults={false}
									/>
								</div>
							</Segment>
						</Portal>
					</React.Fragment>
				)}
			</React.Fragment>
		)
	}
}